// extracted by mini-css-extract-plugin
export default {"loginBtn":"login_loginBtn__cfU-J"};